import type { IconComponentType } from '@unifyapps/defs/blocks/Icon/types';
import type { BlockType } from '@unifyapps/defs/types/block';
import type { AssetDescriptor } from '@unifyapps/network/asset-cache/types';
import { checkIsStaticUrl } from '@unifyapps/network/asset-cache/utils';
import { extractFileNameFromPath } from '../utils/resolveFileTypeFromUploadDetails';

/**
 * Pure function extracted from `IconBlockStateDefinition.getCachableAssets`
 * so it can be imported from a Node tsx script (no React, no React Native).
 *
 * Icons in this codebase are always SVG XML — the runtime renders via
 * `SvgXml`. Emitting `fileType: 'svg'` lets the cache write the file
 * with the correct extension even when the source URL has none (e.g.
 * `/api/file/asset/download/<id>`).
 */
export function iconGetCachableAssets(block: BlockType): Promise<AssetDescriptor[] | undefined> {
  const content = block.component.content as IconComponentType['content'];
  const url = content?.icon;

  if (typeof url !== 'string') return Promise.resolve(undefined);
  if (!checkIsStaticUrl(url)) return Promise.resolve(undefined);

  return Promise.resolve([
    {
      url,
      fileName: extractFileNameFromPath(url),
      fileType: 'svg',
      mimeType: 'image/svg+xml',
    },
  ]);
}
